import React from "react";
import "./QuestionInfoSection.scss";

const QuestionInfoSection = ({
  currentQuestionDetails,
  lang,
  ConvertStringToHTML,
  testQuestionsDetails,
  currentQuestion,
  setLang,
}) => {
  const activeQuestion = testQuestionsDetails?.[currentQuestion] || {};
  const apiType = activeQuestion?.type || currentQuestionDetails?.type || "";
  const isParagraphType = String(apiType).toLowerCase().includes("paragraph");

  const renderSingleQuestion = () => {
    const paragraphEnglishText = isParagraphType
      ? activeQuestion?.p_text || currentQuestionDetails?.p_text || ""
      : "";
    const paragraphHindiText = isParagraphType
      ? activeQuestion?.p_text_hindi || currentQuestionDetails?.p_text_hindi || ""
      : "";
    const questionEnglishText = activeQuestion?.q_text || currentQuestionDetails?.q_text || "";
    const questionHindiText = activeQuestion?.q_text_hindi || currentQuestionDetails?.q_text_hindi || "";

    const mainText = isParagraphType
      ? (lang ? paragraphEnglishText : paragraphHindiText)
      : (lang ? questionEnglishText : questionHindiText);
    const subQuestionText = isParagraphType
      ? (lang ? questionEnglishText : questionHindiText)
      : "";

    const isImage = mainText && mainText.includes("<img");
    const isTable = mainText && mainText.includes("<table");
    const isMTable = mainText && mainText.includes("<mtable");

    return (
      <div>
        {mainText && (
          <p
            className={`${isImage ? "image-style" : ""} ${
              isTable ? "table-style" : ""
            } ${isMTable ? "mtable-style" : ""}`}
            dangerouslySetInnerHTML={{
              __html: mainText,
            }}
          ></p>
        )}

        {isParagraphType && subQuestionText && (
          <p
            dangerouslySetInnerHTML={{
              __html: subQuestionText,
            }}
          ></p>
        )}

        {isTable && <table className="table-style"></table>}
        {isMTable && <mtable className="mtable-style"></mtable>}
      </div>
    );
  };

  return (
    <div className="quesitonInfoSection">
      <div className="text_content_wrapper">
        <div className="typeLanguageWrapper">
          <span>
            <span className="qstnTypeKey">Question Type: </span>
            {testQuestionsDetails[currentQuestion]?.type ||
              testQuestionsDetails[currentQuestion]?.answer_type}
          </span>
        </div>
        <div className="qstnCount">
          Question {`${Number(currentQuestion) + 1}.`}
        </div>
        <div className="questionBox">{renderSingleQuestion()}</div>
      </div>
    </div>
  );
};

export default QuestionInfoSection;
